import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboard } from './hooks';
import { DashboardStats, RecentCalls } from './components';
import { PageLoader, FullWidthContainer } from '../../components';
import { useMinimumLoader } from '../../hooks/useMinimumLoader';

const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  const { data, loading, error } = useDashboard();
  const showLoader = useMinimumLoader(loading, { minimumDuration: 500 });

  if (showLoader) {
    return <PageLoader show={true} />;
  }

  if (error) {
    return (
      <FullWidthContainer>
        <div className="space-y-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              {t('dashboard.title')}
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mt-2">{t('dashboard.welcome')}</p>
          </div>
          <div className="flex items-center justify-center py-12">
            <div className="text-red-500 text-center">
              <p className="text-lg font-semibold">{t('common.error')}</p>
              <p className="text-sm">{error}</p>
            </div>
          </div>
        </div>
      </FullWidthContainer>
    );
  }

  return (
    <FullWidthContainer>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            {t('dashboard.title')}
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">{t('dashboard.welcome')}</p>
        </div>

        {/* Metrics Grid */}
        <DashboardStats metrics={data.metrics} />

        {/* Recent Calls */}
        <RecentCalls calls={data.recentCalls} />
      </div>
    </FullWidthContainer>
  );
};

export { Dashboard };
